import React from 'react';

class ObjectsDetailsContainer extends React.Component {
    render() {
        return this.props.children;
    }
}

export default ObjectsDetailsContainer;
